import { render } from "./AdsTxtValidator.vue?vue&type=template&id=566fcda8&scoped=true"
import script from "./AdsTxtValidator.vue?vue&type=script&lang=js"
export * from "./AdsTxtValidator.vue?vue&type=script&lang=js"

import "./AdsTxtValidator.vue?vue&type=style&index=0&id=566fcda8&lang=scss&scoped=true"
import "./AdsTxtValidator.vue?vue&type=style&index=1&id=566fcda8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566fcda8"]])

export default __exports__